import { AvatarFallback, AvatarImage } from "ui/components/avatar";
import { Avatar } from "ui/components/avatar";
import { Icon } from "components/index";
import { USER } from "icons/src";
// import { ENV } from "shared/env";

// Resolve base URL for both Vite and Next.js runtimes
const resolveBaseUrl = () => {
  const nextUrl =
    typeof process !== "undefined"
      ? process.env?.NEXT_PUBLIC_BASE_URL
      : undefined;
  let viteUrl;
  try {
    // import.meta may not exist in some bundlers
    viteUrl =
      typeof import.meta !== "undefined"
        ? import.meta.env?.VITE_BASE_URL
        : undefined;
  } catch (_) {
    viteUrl = undefined;
  }
  return nextUrl || viteUrl;
};

export const RenderAvatar = ({ user, className }) => {
  const avatarId = user?.avatar;
  const baseUrl = resolveBaseUrl();
  const avatarSrc = avatarId
    ? baseUrl
      ? `${baseUrl}/assets/${avatarId}`
      : null
    : null;

  if (!user) {
    return (
      <Avatar>
        <AvatarFallback className="rounded-lg">
          <Icon icon={USER} className="text-zinc-600" />
        </AvatarFallback>
      </Avatar>
    );
  }

  return (
    <>
      <AvatarImage
        className={className}
        src={avatarSrc}
        alt={user?.first_name}
      />
      <AvatarFallback className="rounded-lg">
        {user?.first_name?.[0] + user?.last_name?.[0]}
      </AvatarFallback>{" "}
    </>
  );
};